import React from 'react';
import BaseImage from './base-image';

interface AvatarProps {
  label?: string;
  image?: string;
  imageAlt?: string;
}

const BaseAvatar: React.FC<AvatarProps> = ({ label, image, imageAlt }) => {
  const labelFirstLetter = label ? label.split('')[0] : '-';

  return image ? (
    <BaseImage
      imgSrc={image}
      imgAlt={imageAlt ?? ''}
      imgClass="w-10 h-10 rounded-full object-cover"
    />
  ) : (
    <div className="bg-gray-200 p-2 rounded-full w-10 h-10 text-center">
      {labelFirstLetter}
    </div>
  );
};

export default BaseAvatar;
